import { Confirm } from '@wix/wix-ui-icons-common'
import cs from 'classnames'
import React, { FC } from 'react'

import s from './WixMobileCheckToggle.scss'
import { wixMobileCheckToggleDataHooks } from './WixMobileCheckToggleDataHooks'

interface WixMobileCheckToggleProps {
  isChecked: boolean
  dataHook?: string
  skin?: 'default' | 'harmony'
}
export const WixMobileCheckToggle: FC<WixMobileCheckToggleProps> = ({ isChecked, dataHook, skin = 'default' }) => {
  const isHarmony = skin === 'harmony'
  return (
    <div
      className={cs(s.toggle, {
        [s.checked]: isChecked,
        [s.harmony]: isHarmony,
      })}
      data-hook={dataHook}
    >
      {isChecked &&
        (isHarmony ? (
          <div className={s.harmonyDot} data-hook={wixMobileCheckToggleDataHooks.icon()} />
        ) : (
          <Confirm size="24px" className={s.icon} data-hook={wixMobileCheckToggleDataHooks.icon()} />
        ))}
    </div>
  )
}
